import React from 'react';
import Layout from '../components/Layout'; // 引入 Layout 组件
import './RagAgentPage.css'

function RagAgent() {
    return (
        <Layout>
            <div className="chat-page-container">
                <iframe
                    src="http://data.sanway.tech:8080/chat/share?shared_id=6d47d1fae83b11efbe390242ac180006&from=agent&auth=112233"

                    title="Ragflow Agent 凯大师智能助手"
                ></iframe>
            </div>
        </Layout>
    );
}

export default RagAgent;